module.exports = __webpack_public_path__ + "img/ic_country_serve_img5.d3cceaa3.png";